import { useEffect } from 'react';

const useTitle = (title?: string | null | undefined) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} - PitchHub` : 'PitchHub';

    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};

export default useTitle;
